import styled from 'styled-components';
import {useToast} from "@chakra-ui/react";

import CommunityLogo from './community_logo';
import Button from './button';
import {themecolors} from "../utils/themecolors";

const Subscribe = styled(Button)``;
const Info = styled.div``;
const DisplayName = styled.div``;
const Name = styled.div``;
const Logo = styled.div``;
const Description = styled.div``;

const SubscribeButton = styled.div``;

const Community = styled(({className, community, onClick, onSubscribe, condensed, subscribe, style}) => {
    const {name} = community;
    const toast = useToast();
    const handleSubscribe = async () => {
        try {
            await onSubscribe(community);
        } catch {
            toast({
                title: `Failed to subscribe.`,
                status: 'error',
                isClosable: true,
            });
        }
    }
    return (
        <div className={className} onClick={onClick} style={style}>
            <Logo>
                <CommunityLogo name={name} />
            </Logo>
            <Info>
                <DisplayName>
                    {condensed ? community.name : community.display_name}
                </DisplayName>
                {!condensed &&
                    <>
                        <Name>
                            /c/{community.name}
                        </Name>
                        <Description>
                            {community.description ? community.description : 'No description found.'}
                        </Description>
                    </>
                    }
            </Info>
            {(!condensed || subscribe) && !community.is_subscribed &&
                <Subscribe onClick={handleSubscribe}>
                    <SubscribeButton>
                        {community.is_subscribed ? 'Leave' : 'Join'}
                    </SubscribeButton>
                </Subscribe>
            }
        </div>
    );
})`
  display: flex;
  padding: 0px 16px;
  height: 56px;
  &:active {
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : 'rgba(0,0,0,.06)'};
  }

  ${({condensed}) => condensed ? `
  align-items: center;
  ` : ``}
  
  img {
    width: 32px;
    height: 32px;
    min-width: 32px;
    margin-right: 12px;
    border-radius: 100px;
  }
  
  ${DisplayName} {
    font-size: 16px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
    font-weight: 600;
  }
  ${Name} {
    font-size: 12px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Description} {
    margin-top: 6px;
    font-size: 13px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  
  ${Info} {
    display: flex;
    flex-direction: column;
  }

  ${Subscribe} {
    margin-left: auto;
    background-color: inherit;
  }
  
  ${SubscribeButton} {
    font-size: 15px;
    font-weight: 600;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : themecolors.pure_black};
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_black : themecolors.pure_white};
    padding: 6px 16px;
    border-radius: 48px;
  }
`;

export default Community;
